
/* ===== VELANTIS_DGIFT — pop-up 100 ml gratis en difusores ===== */
(function(){
  var t=document.getElementById('dgiftToast'), x=document.getElementById('dgiftX');
  if(!t) return; var timer=null, closedFor='';
  function show(){ clearTimeout(timer); t.classList.add('show'); timer=setTimeout(hide,9000); }
  function hide(){ clearTimeout(timer); t.classList.remove('show'); }
  if(x) x.addEventListener('click',function(){ closedFor=location.hash; hide(); });
  function onRoute(){ if(/^#\/difusores\/?$/.test(location.hash||'')){ if(closedFor!==location.hash) setTimeout(show,700); } else hide(); }
  window.addEventListener('hashchange',onRoute);
  if(document.readyState!=='loading') onRoute(); else document.addEventListener('DOMContentLoaded',onRoute);
})();
